import React, { useContext, useEffect, useState } from 'react';
import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { ProgressNotes } from '@mummssoftware/utils/constants';
import { GlobalContext, OPEN_WIDGET } from '../GlobalContext';
import { PNCounterContext } from './PNCounterContext';
const StyledTooltip = withStyles({
  tooltip: {
    color: 'white',
    backgroundColor: 'gray',
    fontSize: '1em'
  }
})(Tooltip);
const Tag = styled.div.withConfig({
  displayName: "PNCounterIcon__Tag",
  componentId: "sc-16n5ud6-0"
})(["", " ", " width:20px;height:20px;cursor:pointer;padding:1px;margin-left:5px;border-radius:2px;display:flex;flex-direction:row;align-items:center;align-content:center;justify-content:center;font-family:'Muli',sans-serif;font-size:0.85rem;font-weight:500;line-height:1;"], props => `background-color: ${props.theme.palette.success.light};`, props => `color: ${props.theme.palette.background.paper};`);
export const PNCounterIcon = ({
  patientNumber,
  entityKey,
  entityType,
  entityName,
  onIconClick,
  view,
  count,
  openEntityWidget
}) => {
  var _pnCounterContext$cou;

  const pnCounterContext = useContext(PNCounterContext);
  const globalContext = useContext(GlobalContext);
  const shouldOpenEntityWidget = openEntityWidget !== null && openEntityWidget !== void 0 ? openEntityWidget : !!(entityType && entityKey); // Store the value we will be display in state

  const [countValue, setCountValue] = useState({
    entitytype: '',
    entitykey: '',
    count: '0'
  }); // When the countValues in the context changes, find the countValue for *this*
  // entityType and entityKey and save it to our state

  useEffect(() => {
    if (count != null && count !== '') {
      setCountValue({
        entitytype: entityType || '',
        entitykey: entityKey || '',
        count: String(count)
      });
      return;
    }

    let val = entityType && pnCounterContext.countValues && pnCounterContext.countValues[patientNumber] && pnCounterContext.countValues[patientNumber][entityType] && Array.isArray(pnCounterContext.countValues[patientNumber][entityType]) && pnCounterContext.countValues[patientNumber][entityType].find(arrayValue => arrayValue.entitykey === entityKey && arrayValue.entitytype === entityType);

    if (!val) {
      // We couldn't find an entry for *this* entityType/entityKey, so create one with a 0 count
      val = {
        entitytype: entityType || '',
        entitykey: entityKey || '',
        count: '0'
      };
      val.count = '0';
    }

    setCountValue(val);
  }, [count, entityType, entityKey, patientNumber, pnCounterContext.countValues, pnCounterContext.countValues && entityType && pnCounterContext.countValues[patientNumber] && ((_pnCounterContext$cou = pnCounterContext.countValues[patientNumber][entityType]) === null || _pnCounterContext$cou === void 0 ? void 0 : _pnCounterContext$cou.length), pnCounterContext.refresh, pnCounterContext.refreshIcon]);
  const displayCount = countValue.count; // The icon was clicked. Open the Orders and Progress Notes widget.
  // TODO add an identifier that PN was open from icon

  const handleIconClick = () => {
    if (onIconClick) {
      onIconClick();
    }

    if (shouldOpenEntityWidget && globalContext && globalContext.dispatch && entityType && entityKey) {
      globalContext.dispatch({
        type: OPEN_WIDGET,
        payload: {
          componentName: ProgressNotes,
          filter: {
            entityType,
            entityKey,
            entityName,
            patientNumber,
            view
          }
        }
      });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTooltip, {
    title: `${parseInt(displayCount, 10) === 0 ? 'No' : displayCount} related note${parseInt(displayCount, 10) !== 1 ? 's' : ''}`
  }, /*#__PURE__*/React.createElement(Tag, {
    onClick: handleIconClick
  }, displayCount)));
};
export default PNCounterIcon;